import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GoalIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Goal",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 2C8.27 2 2 8.27 2 16s6.27 14 14 14 14-6.27 14-14S23.73 2.01 16 2m0 24.5c-5.8 0-10.5-4.7-10.5-10.5S10.2 5.5 16 5.5 26.5 10.2 26.5 16 21.8 26.49 16 26.5m0-18.67c-4.51 0-8.17 3.66-8.17 8.17s3.66 8.17 8.17 8.17 8.17-3.66 8.17-8.17S20.51 7.84 16 7.83m0 12.83c-2.58 0-4.67-2.09-4.67-4.67s2.09-4.67 4.67-4.67 4.67 2.09 4.67 4.67-2.09 4.67-4.67 4.67m2.33-4.67c0 1.29-1.04 2.33-2.33 2.33s-2.33-1.04-2.33-2.33 1.04-2.33 2.33-2.33 2.33 1.04 2.33 2.33"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.86 31.86c-8.83 0-16-7.18-16-16s7.17-16 16-16 16 7.18 16 16-7.18 16-16 16m0-29.72C8.3 2.14 2.15 8.29 2.15 15.85S8.3 29.56 15.86 29.56s13.71-6.15 13.71-13.71S23.42 2.14 15.86 2.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 25c-5.04 0-9.14-4.1-9.14-9.14s4.1-9.15 9.14-9.15S25 10.81 25 15.85s-4.1 9.14-9.14 9.14Zm0-16C12.08 9 9 12.08 9 15.86s3.08 6.86 6.86 6.86 6.86-3.08 6.86-6.86S19.64 9 15.86 9"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "15.86",
        cy: "15.86",
        r: "1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 18.14a2.29 2.29 0 1 1 0-4.58 2.29 2.29 0 0 1 0 4.58"
      })]
    })
  }));
};
GoalIcon.displayName = 'GoalIcon';